module.exports = __webpack_public_path__ + "img/preview.7f9b07df.png";